

<div class="generic-list">
  @for (act of data.actions; track act; let i = $index) {
    @if (i > 0) {
      <mat-divider></mat-divider>
    }
    <div class="generic-list-item" style="padding: 0 1rem" (click)="openLink(act, $event)">
      @if (act.icon) {
        <mat-icon [svgIcon]="act.icon"></mat-icon>
      }
      <div class="_content"><div class="_title">{{act.text | translate}}</div></div>
    </div>
  }
</div>
